export function parsePrice(value: unknown): number | null {
  if (typeof value !== "number" && typeof value !== "string") return null
  if (typeof value === "string" && !value.trim()) return null

  const price = Number(value)
  return Number.isFinite(price) && price >= 0 ? price : null
}
